import type {
  PublicTrip,
  PublicStop
} from "@busbud/core-types/dist/lib/poll-service/api";

import type { LegIndex } from "@app/constants/trip";
import { OUTBOUND_LEG_INDEX, RETURN_LEG_INDEX } from "@app/constants/trip";

import {
  getOutboundLegOriginDestinationSegments,
  getReturnLegOriginDestinationSegments
} from "./get-leg-origin-destination-segments";
import { throwsIfAccessingReturnLegOfOnewayTrip } from "./leg-access-guard";

type LegStops = { origin: PublicStop | null; destination: PublicStop | null };

export function getOutboundLegStops(trip: PublicTrip): LegStops {
  return getLegStops(OUTBOUND_LEG_INDEX, trip);
}

export function getReturnLegStops(trip: PublicTrip): LegStops {
  return getLegStops(RETURN_LEG_INDEX, trip);
}

function getLegStops(leg_index: LegIndex, trip: PublicTrip): LegStops {
  throwsIfAccessingReturnLegOfOnewayTrip(trip, leg_index);

  const getSegments =
    leg_index === OUTBOUND_LEG_INDEX
      ? getOutboundLegOriginDestinationSegments
      : getReturnLegOriginDestinationSegments;

  const { origin_segment, destination_segment } = getSegments(trip);

  return {
    origin: origin_segment.origin,
    destination: destination_segment.destination
  };
}
